module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/娱乐摄像模组1-ja.d599d689.png";